import { useEffect, useState } from "react";

// Subscribe to a CSS media query from JS. The split-switch launcher and
// voice/text picker size themselves with inline px, which a CSS @media rule
// can't reach, so they branch on this instead. Safe when matchMedia is missing
// (SSR / old jsdom): returns false.
export function useMediaQuery(query: string): boolean {
  const get = () =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(query).matches
      : false;

  const [matches, setMatches] = useState(get);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return;
    }
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
